import React, { useState } from 'react';
import { Grid, Paper, Typography, Stack, Divider } from '@esgian/esgianui';
import PropTypes from 'prop-types';
import { OperatorCiiRatingTable, OperatorCiiRatingChart } from './index';
import AccreditationStatementModal from '@components/Modals/AccreditationStatementModal';
import { OperatorCIIDisclaimer } from '@components';
import { TextWithTooltipIcon } from '@components';
import { OPERATOR_PROFILE_FLEET_CII_RATING_TEXT } from '@constants/tooltips';

function OperatorCiiRatingSection({
  operatorCiiRatingQuery = '',
  operatorShortName = '',
  operatorLongName = ''
}) {
  const [showStatement, setShowStatement] = useState(false);

  return (
    <>
      <Grid item xs={12}>
        <Paper sx={{ display: 'flex' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Stack spacing={2} sx={{ p: 2 }}>
                <Stack>
                  <TextWithTooltipIcon
                    label={<Typography variant={'h6'}>Fleet CII rating</Typography>}
                    tooltipText={OPERATOR_PROFILE_FLEET_CII_RATING_TEXT}
                  />
                  <Typography color={'text.secondary'} variant={'body2'}>
                    {operatorLongName}
                  </Typography>
                </Stack>
                <Divider />
                <OperatorCIIDisclaimer setShowStatement={setShowStatement} />
                <OperatorCiiRatingChart
                  fileName={`${operatorShortName}-cii-rating`}
                  loading={operatorCiiRatingQuery.isFetching}
                  ciiRatingData={operatorCiiRatingQuery.data}
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <OperatorCiiRatingTable
                fileName={`${operatorShortName}-cii-rating`}
                ciiRatingData={operatorCiiRatingQuery.data}
                loading={operatorCiiRatingQuery.isFetching}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <AccreditationStatementModal
        handleClose={() => setShowStatement(false)}
        open={showStatement}
      />
    </>
  );
}

OperatorCiiRatingSection.propTypes = {
  operatorCiiRatingQuery: PropTypes.object,
  operatorShortName: PropTypes.string,
  operatorLongName: PropTypes.string
};

export default OperatorCiiRatingSection;
